import axios from 'axios'

export default {
  list (context, opts) {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/permission')
        .then(({ data }) => {
          // context.commit('LIST', data)
          const permissions = data.reduce((res, perm) => {
            if (!res.models[perm.model]) {
              res.models[perm.model] = {}
            }
            if (!res.actions[perm.action]) {
              res.actions[perm.action] = {}
            }
            res.models[perm.model][perm.action] = perm.id
            return res
          }, { models: {}, actions: {} })
          context.commit('ACTIONS', Object.keys(permissions.actions))
          context.commit('MODELS', permissions.models)
          resolve(data)
        }).catch((error) => {
          context.commit('ACTIONS', [])
          context.commit('MODELS', [])
          context.commit('LIST', null)
          reject(error)
        })
    })
  },
  models (context, opts) {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/permission')
        .then(({ data }) => {
          const permissions = data.reduce((res, perm) => {
            if (!res.models[perm.model]) {
              res.models[perm.model] = {}
            }
            if (!res.actions[perm.action]) {
              res.actions[perm.action] = {}
            }
            res.models[perm.model][perm.action] = perm.id
            return res
          }, { models: {}, actions: {} })
          context.commit('ACTIONS', Object.keys(permissions.actions))
          context.commit('MODELS', permissions.models)
          resolve(data)
        }).catch((error) => {
          context.commit('ACTIONS', [])
          context.commit('MODELS', [])
          reject(error)
        })
    })
  }
}
